import React from 'react'
import '../styles/style.css'

class Popup extends React.Component {
    render() {

        return (
            <div className="modal" onClick={this.props.onClick}>
                <div className="modal-content br-12">
                    <div className="modal-heading">                      
                        <p className={this.props.error?"popup-r":"popup-p"}>{this.props.heading}</p>
                    </div>
                    <div className="apply-modal-header">
                        <p>{this.props.msg}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Popup;